import { ref } from 'vue'
const data = ref({
  isAuthenticated: false
})

export interface useAuthenticationDataModule {
  data: typeof data
  setAuthenticated: (value: boolean) => void
}

export const useAuthenticationData: () => useAuthenticationDataModule = () => {
  const setAuthenticated = (value: boolean) => {
    data.value.isAuthenticated = value
  }
  return {
    data,
    setAuthenticated
  }
}
